import { useEffect, useState } from "react";
import SubStepProgress from "./components/subStepProgress";
import {
  IFreshmanProcess,
  IMainStepConfiguration,
} from "../../models/freshman/freshmanProcess";
import { connect, useDispatch } from "react-redux";
import { getAllMainStepPercentage } from "../../action/freshman/freshmanProcessActionCreator";
import { getStudentInfoDetails } from "../../action/student/studentInfoActionCreator";
import {
  setMainStepProcess,
  setSubStepProcess,
} from "../../store/slices/freshman/freshmanProcessSlice";
import LoaderSpinner from "../../common-components/loader";
import { alertConstants, getAlertData } from "../../helper/sweet-alert";
import SweetAlert from "react-bootstrap-sweetalert";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../constants/routerUrl";

const FreshmanProcess = (props: IFreshmanProcess) => {
  const {
    getAllMainStepPercentage,
    getStudentInfoDetails,
    mainStepPercentage,
    currentUserId,
    studentInfo,
  } = props;
  const dispatch = useDispatch();
  const [showPercentage, setShowPercentage] = useState<number | null>(0);
  const [mainStepId, setMainStepId] = useState<number | undefined>();
  const [isMainStepLoading, setIsMainStepLoading] = useState<boolean>(false);
  const [mainStepName, setMainStepName] = useState<string>(
    mainStepPercentage && mainStepPercentage.length > 0
      ? String(mainStepPercentage[0]?.mainStepName)
      : ""
  );
  const handlePercentage = (id: number) => {
    setShowPercentage((prev) => (prev === id ? null : id));
  };
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [showConfirm, setShowConfirm] = useState<boolean>(true);
  const [alertType, setAlertType] = useState<any>("");
  const [alertTitle, setAlertTitle] = useState<any>("");
  const [hasFetchedMainSteps, setHasFetchedMainSteps] = useState(false);
  const navigate = useNavigate();

  // select classname according to mainstep percentage and prerequisite average percentage
  const selectClass = (data: IMainStepConfiguration) => {
    if (data.totalPercentage > 0 && data.totalPercentage <= 99) {
      return "inprogress";
    } else if (data.totalPercentage === 100) {
      return "completed";
    } else if (
      data.prerequisites.length != 0 &&
      data.prerequisitesTotalPercentage != 100
    ) {
      return "";
    } else if (data.totalPercentage === 0) {
      return "next-task";
    } else {
      return "";
    }
  };

  const setSubStep = (data: IMainStepConfiguration) => {
    if (
      !(
        data.prerequisites.length != 0 &&
        data.prerequisitesTotalPercentage != 100
      )
    ) {
      setMainStepId(data.mainStepId);
      setMainStepName(String(data.mainStepName));
    }
  };

  useEffect(() => {
    if (mainStepPercentage?.length > 0 && mainStepId === undefined) {
      setMainStepId(mainStepPercentage[0].mainStepId);
      setMainStepName(String(mainStepPercentage[0]?.mainStepName ?? ""));
    }
  }, [mainStepPercentage]);

  useEffect(() => {
    const getMainSteps = async () => {
      setIsMainStepLoading(true);
      try {
        await getAllMainStepPercentage();
      } finally {
        setHasFetchedMainSteps(true);
        setIsMainStepLoading(false);
      }
    };
    getMainSteps();
    currentUserId && getStudentInfoDetails(currentUserId);
    const element = document.querySelector(".admin-wrap");
    if (element) {
      element.classList.remove("admin-wrap");
    }
    return () => {
      dispatch(setMainStepProcess([]));
      dispatch(setSubStepProcess([]));
      setMainStepId(0);
    };
  }, []);

  useEffect(() => {
    if (hasFetchedMainSteps && mainStepPercentage?.length === 0) {
      const alertData = getAlertData(
        alertConstants.custom,
        undefined,
        alertConstants.error,
        "No Process Configured Please Contact Your Admin"
      );
      if (alertData) {
        setShowAlert(true);
        setAlertType(alertData.type);
        setAlertTitle(alertData.title);
      }
    }
  }, [mainStepPercentage, hasFetchedMainSteps]);

  return (
    <>
      <div className="row freshman-wrap">
        <div className="col-md-3">
          <div className="task-wrap card-wrap">
            <div className="list-course-freshman">
              <p>
                Program level - <strong>{studentInfo?.studentLevel}</strong>
              </p>
              <p>
                International student -{" "}
                <strong>
                  {studentInfo?.studentStatus?.internationalStudent}
                </strong>
              </p>
              <p>
                College - <strong>{studentInfo?.division}</strong>
              </p>
            </div>
            <ul className="task-list">
              {isMainStepLoading ? (
                <LoaderSpinner />
              ) : (
                mainStepPercentage?.map(
                  (mainStep: IMainStepConfiguration, index: number) => (
                    <li
                      onClick={() => setSubStep(mainStep)}
                      className={selectClass(mainStep)}
                      key={mainStep.mainStepId}
                      title={mainStep.description}
                    >
                      <div className="top">
                        <div className="leftwrap">
                          <span>{index + 1}</span>
                          <div>
                            <h6>{mainStep.mainStepName}</h6>
                            <p className="para-hide-2">
                              {mainStep.description}
                            </p>
                          </div>
                        </div>
                        <div
                          className="rightwrap"
                          onClick={() => handlePercentage(mainStep.mainStepId)}
                        >
                          {mainStep.mainStepId === showPercentage ? (
                            <button className="btn-accord">
                              <i className="fa-solid fa-angle-down"></i>
                            </button>
                          ) : (
                            <button className="btn-accord">
                              <i className="fa-solid fa-angle-up"></i>
                            </button>
                          )}
                          <div className="task-success">
                            <svg
                              width="21"
                              height="21"
                              viewBox="0 0 21 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M5.83358 2.3187C6.63765 2.2545 7.40097 1.93824 8.01482 1.41495C8.70815 0.824436 9.58911 0.500122 10.4998 0.500122C11.4105 0.500122 12.2915 0.824436 12.9848 1.41495C13.5987 1.93824 14.362 2.2545 15.1661 2.3187C16.0741 2.39127 16.9266 2.7849 17.5707 3.42903C18.2149 4.07316 18.6085 4.92566 18.6811 5.8337C18.7448 6.63745 19.0611 7.4012 19.5848 8.01495C20.1753 8.70827 20.4996 9.58923 20.4996 10.4999C20.4996 11.4107 20.1753 12.2916 19.5848 12.9849C19.0615 13.5988 18.7453 14.3621 18.6811 15.1662C18.6085 16.0742 18.2149 16.9267 17.5707 17.5709C16.9266 18.215 16.0741 18.6086 15.1661 18.6812C14.362 18.7454 13.5987 19.0617 12.9848 19.5849C12.2915 20.1755 11.4105 20.4998 10.4998 20.4998C9.58911 20.4998 8.70815 20.1755 8.01482 19.5849C7.40097 19.0617 6.63765 18.7454 5.83358 18.6812C4.92554 18.6086 4.07303 18.215 3.42891 17.5709C2.78478 16.9267 2.39114 16.0742 2.31857 15.1662C2.25438 14.3621 1.93811 13.5988 1.41482 12.9849C0.824314 12.2916 0.5 11.4107 0.5 10.4999C0.5 9.58923 0.824314 8.70827 1.41482 8.01495C1.93811 7.40109 2.25438 6.63777 2.31857 5.8337C2.39114 4.92566 2.78478 4.07316 3.42891 3.42903C4.07303 2.7849 4.92554 2.39127 5.83358 2.3187ZM15.1336 8.8837C15.3613 8.64794 15.4873 8.33219 15.4844 8.00445C15.4816 7.6767 15.3501 7.36318 15.1183 7.13142C14.8866 6.89966 14.5731 6.7682 14.2453 6.76535C13.9176 6.76251 13.6018 6.8885 13.3661 7.1162L9.24982 11.2324L7.63357 9.6162C7.39782 9.3885 7.08207 9.26251 6.75432 9.26535C6.42658 9.2682 6.11306 9.39966 5.8813 9.63142C5.64954 9.86318 5.51808 10.1767 5.51523 10.5044C5.51238 10.8322 5.63838 11.1479 5.86608 11.3837L8.36608 13.8837C8.60048 14.118 8.91837 14.2497 9.24982 14.2497C9.58128 14.2497 9.89917 14.118 10.1336 13.8837L15.1336 8.8837Z"
                                fill="#025A10"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                      {mainStep.mainStepId === showPercentage && (
                        <div className="btm">
                          <div className="task-progress">
                            <span
                              style={{
                                width: `${Math.round(
                                  mainStep.totalPercentage
                                )}%`,
                              }}
                            ></span>
                          </div>
                          <div className="percentage">
                            <span>{Math.round(mainStep.totalPercentage)}</span>%
                            completed
                          </div>
                        </div>
                      )}
                    </li>
                  )
                )
              )}
            </ul>
          </div>
        </div>
        <SubStepProgress mainStepName={mainStepName} mainStepId={mainStepId} />
        <SweetAlert
          show={showAlert}
          type={alertType}
          title={alertTitle}
          onConfirm={() => {
            setShowAlert(false);
            navigate(ROUTER_URL.STUDENT_DASHBOAD);
          }}
          showCancel={false}
          showCloseButton={true}
          closeBtnStyle={{ color: "#948256" }}
          showConfirm={showConfirm}
        />
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getAllMainStepPercentage: () => getAllMainStepPercentage(),
  getStudentInfoDetails: (id: string) => getStudentInfoDetails(id),
};

function mapStateToProps(state: any) {
  return {
    mainStepPercentage: state.freshmanProcess.mainStepProcess,
    currentUserId: state.userDetails.userProfileData?.id,
    studentInfo: state.studentInfo.studentInfo,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FreshmanProcess);
